import { Oriented, mapOrientedToName } from "@/data/constants/oriented";
import { SymbolInfo } from "@/features/analysis/services/symbol-info";

import { RadarInfoProps, TickInfoProps } from "ui/analysis/radar-chart";

export const getRadarData = ({
  data,
  radarTexts,
}: {
  data?: SymbolInfo;
  radarTexts: ReturnType<typeof mapOrientedToName>;
}): { [key in Oriented]: number } =>
  Object.keys(radarTexts).reduce(
    (acc, key) => ({
      ...acc,
      [radarTexts[key as Oriented]]: (data?.[key as Oriented] as number) ?? 0,
    }),
    {} as {
      [key in Oriented]: number;
    }
  );

export const radarInfo: RadarInfoProps = {
  dotFill: "#0284C7",
  dotRadius: 10,
  dotFontSize: 14,
  dotTextOffset: 5,
  gradientEnd: "#0284C700",
  gradientStart: "#0284C799",
};

export const tickInfo: TickInfoProps = {
  activeNameColor: "#71717A80",
  passiveNameColor: "#71717A80",
  focusNameColor: "#27272A",
};
